"use client";

import { useEffect, useRef } from "react";
import { useSession } from "next-auth/react";
import { getPendingCheckout, resumePendingCheckout } from "@/libs/pendingCheckout";

/**
 * After email magic-link sign-in the user lands back on `callbackUrl` with a
 * fresh page load. If they had picked a plan before signing in, resume Stripe
 * checkout automatically (sessionStorage or URL params).
 */
export default function PendingCheckoutResume(): null {
  const { status } = useSession();
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (status !== "authenticated" || attemptedRef.current) return;

    const intent = getPendingCheckout();
    if (!intent?.resumeAfterAuth) return;

    attemptedRef.current = true;
    void resumePendingCheckout({ waitForSession: true });
  }, [status]);

  return null;
}
